import { useEffect } from 'react';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import AboutHero from './components/AboutHero';
import AboutStats from './components/AboutStats';
import AboutValues from './components/AboutValues';
import AboutHistory from './components/AboutHistory';
import AboutTeam from './components/AboutTeam';
import AboutLicenses from './components/AboutLicenses';
import SeoHead, { SITE_URL } from '@/components/feature/SeoHead';

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: 'О компании NeonPharma',
  description: 'История, ценности и команда интернет-аптеки NeonPharma. Лицензированная аптека с 2009 года, более 1000 аптек по всей России.',
  url: `${SITE_URL}/about`,
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Главная', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'О компании', item: `${SITE_URL}/about` },
    ],
  },
  mainEntity: {
    '@type': 'Organization',
    name: 'NeonPharma',
    foundingDate: '2009',
    numberOfEmployees: { '@type': 'QuantitativeValue', value: 500 },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'ул. Ивана Франко, д. 8',
      addressLocality: 'Москва',
      postalCode: '121108',
      addressCountry: 'RU',
    },
  },
};

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen" style={{ background: '#050508' }}>
      <SeoHead
        title="О компании NeonPharma — история, команда, лицензии"
        description="NeonPharma — лицензированная интернет-аптека с 2009 года. Более 1000 аптек по всей России, команда профессиональных фармацевтов, японские формулы здоровья."
        keywords="о компании, NeonPharma, история аптеки, команда фармацевтов, лицензия"
        canonical="/about"
        jsonLd={aboutJsonLd}
      />
      <Navbar />
      <AboutHero />
      <AboutStats />
      <AboutValues />
      <AboutHistory />
      <AboutTeam />
      <AboutLicenses />
      <Footer />
    </div>
  );
};

export default AboutPage;
